import { DateTime, Info } from 'luxon';
export const HIGHEST_EDUCATION_LEVEL = {
  'MIDDLE_SCHOOL': 'Middle School',
  'GRADE_NINE': '9th Grade',
  'GRADE_TEN': '10th Grade',
  'GRADE_ELEVEN': '11th Grade',
  'GRADE_TWELVE': '12th Grade',
  'COMPLETED_HS_NOT_ENROLLED_IN_COLLEGE': 'Completed HS; not yet enrolled in college',
  'COMPLETED_HS_NOT_GOING_COLLEGE': 'Completed HS; will not attend college',
  'CURRENTLY_ENROLLED_IN_COLLEGE': 'Currently Enrolled in College',
  'COLLEGE_GRADUATE': 'College Graduate',
  'OTHER': 'Other'
};
export const ORGANIZATION_TYPES = {
  'RT_JC': 'Public 2 Year College',
  'RT_JC_PR': 'Private 2 Year College',
  'RT_UNIV': 'Public University/4 Year College',
  'RT_UNIV_PR': 'Private University/4 Year College',
  'RT_TECH': 'Technical College',
  'RT_CAREER': 'Career College',
  'RT_SCHOLARSHIP': 'Scholarship Fund',
  'RT_APPSVC': 'Application Service',
  'RT_CREDORG': 'Credentialing Organization',
  'RT_EMPLYR': 'Employer',
  'RT_HS': 'High School',
  'RT_VERORG': 'Verification Organization',
  'RT_GOV': 'Government',
  'RT_MILITARY': 'Military'
};
function mapToArrayOptions(mapping, reducer) {
  return Object.entries(mapping).reduce(reducer, []);
}
export const EDUCATION_LEVEL_OPTIONS = mapToArrayOptions(HIGHEST_EDUCATION_LEVEL, (options, _ref) => {
  let [key, value] = _ref;
  return [...options, {
    value: key,
    label: value
  }];
});
export const ORGANIZATION_TYPES_OPTIONS = mapToArrayOptions(ORGANIZATION_TYPES, (options, _ref2) => {
  let [key, value] = _ref2;
  return [...options, {
    value: key,
    label: value
  }];
});
export const MONTH_OPTIONS = mapToArrayOptions(Info.months(), (options, _ref3) => {
  let [key, value] = _ref3;
  const monthValue = parseInt(key) + 1;
  return [...options, {
    value: monthValue.toString(),
    label: value
  }];
});
export const DAY_OPTIONS = mapToArrayOptions(Array.from({
  length: 31
}, (_, i) => i + 1), (options, _ref4) => {
  let [key, value] = _ref4;
  const dayValue = parseInt(key) + 1;
  return [...options, {
    value: dayValue.toString(),
    label: value.toString()
  }];
});
const currentYear = DateTime.local().year;
export const YEAR_OPTIONS = mapToArrayOptions(Array.from({
  length: 100
}, (_, i) => i + 1), (options, _ref5) => {
  let [key] = _ref5;
  const yearValue = currentYear - (100 - parseInt(key));
  return [...options, {
    value: yearValue.toString(),
    label: yearValue.toString()
  }];
});
export function verifiedDaysInMonthOptions(month, year) {
  const days = verifiedDaysInMonth(+month, +year);
  return mapToArrayOptions(Array.from({
    length: days
  }, (_, i) => i + 1), (options, _ref6) => {
    let [key, value] = _ref6;
    const dayValue = parseInt(key) + 1;
    return [...options, {
      value: dayValue.toString(),
      label: value.toString()
    }];
  });
}
function verifiedDaysInMonth(month, year) {
  // If we have the month & year, we can always get the exact days including leap years
  if (month && year) {
    return new Date(year, month, 0).getDate();
  }
  // If we have only the month give the approximate expected days
  if (month) {
    switch (month) {
      case 2:
        // Feb
        return 28;
      case 4: // March
      case 6: // June
      case 9: // Sept
      case 11:
        // Nov
        return 30;
    }
  }
  // Default to 31 in all other scenarios
  // If 31 is wrong, it will be caught once month & year are filled out on the form and checked against Date() obj
  return 31;
}